var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message-center-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "message-center",
        attrs: { id: "qa-message-center" },
        on: {
          click: function($event) {
            $event.stopPropagation()
            _vm.dialog = true
          }
        }
      },
      [
        _vm.noOfMessages > 0
          ? _c(
              "div",
              {
                staticClass: "message-number",
                attrs: { id: "qa-message-number" }
              },
              [_vm._v(_vm._s(_vm.noOfMessages))]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "v-dialog",
          {
            attrs: { "content-class": "message-center-dialog" },
            model: {
              value: _vm.dialog,
              callback: function($$v) {
                _vm.dialog = $$v
              },
              expression: "dialog"
            }
          },
          [
            _c(
              "div",
              { staticClass: "msg_center_header" },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Account.MessageCenter")))
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.dialog = false
                      }
                    }
                  },
                  [_vm._v("close")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "message-center-container" },
              [
                _vm.noOfMessages === 0
                  ? _c(
                      "v-card",
                      { staticClass: "no-msgs ms-chld" },
                      [
                        _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                          _vm._v(_vm._s(_vm.$t("MessageCenter.NoNewMsgs")))
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.nonVerified
                  ? _c(
                      "v-card",
                      { staticClass: "ms-chld" },
                      [
                        _c(
                          "span",
                          { staticClass: "ms-info-wrapper" },
                          [
                            _c("v-icon", { staticClass: "ms-info" }, [
                              _vm._v("info_outline")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                          _vm._v(
                            _vm._s(_vm.$t("Account.NotVerified")) +
                              " " +
                              _vm._s(_vm.$t("Account.NotVerified.Info")) +
                              " "
                          ),
                          _c("u", [
                            _c(
                              "span",
                              {
                                staticClass: "here",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.go2VerificationPage.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Account.NotVerified.Info.Here")
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(
                            _vm._s(_vm.$t("Account.NotVerified.Info.Details"))
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.lifetimeDepositReached
                  ? _c(
                      "v-card",
                      { staticClass: "ms-chld" },
                      [
                        _c(
                          "span",
                          { staticClass: "ms-info-wrapper" },
                          [
                            _c("v-icon", { staticClass: "ms-info" }, [
                              _vm._v("info_outline")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.DepositThreshold.Info", {
                                currency: _vm.currencySymbol
                              })
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("v-card-text", {
                          staticClass: "tl-alert-msg tl-info",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("Account.DepositThreshold.Info.Details", {
                                currency: _vm.currencySymbol
                              })
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.DepositThreshold.Info.Second")
                            ) + " "
                          ),
                          _c("u", [
                            _c(
                              "span",
                              {
                                staticClass: "here",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.go2ResponsibleGaming.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Account.DepositThreshold.Info.Here")
                                  )
                                )
                              ]
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pendingInvestigation
                  ? _c(
                      "v-card",
                      { staticClass: "ms-chld" },
                      [
                        _c(
                          "span",
                          { staticClass: "ms-info-wrapper" },
                          [
                            _c("v-icon", { staticClass: "ms-info" }, [
                              _vm._v("info_outline")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.Ovelay.Pending.Investigation")
                            )
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSuspended
                  ? _c(
                      "v-card",
                      { staticClass: "ms-chld" },
                      [
                        _c(
                          "span",
                          { staticClass: "ms-info-wrapper" },
                          [
                            _c("v-icon", { staticClass: "ms-info" }, [
                              _vm._v("info_outline")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                          _vm._v(_vm._s(_vm.$t("Account.Ovelay.Suspension")))
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pwdPolicyAlert
                  ? _c(
                      "v-card",
                      { staticClass: "ms-chld" },
                      [
                        _c(
                          "span",
                          { staticClass: "ms-info-wrapper" },
                          [
                            _c("v-icon", { staticClass: "ms-info" }, [
                              _vm._v("info_outline")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.showPwdDaysLeftInfo
                          ? _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.pwdDays == 1
                                    ? _vm.$t(
                                        "Account.PasswordPolicy.Alert.Info1"
                                      )
                                    : _vm.$t(
                                        "Account.PasswordPolicy.Alert.Info",
                                        { pwdDays: _vm.pwdDays }
                                      )
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Account.PasswordPolicy.Alert.ChangePassword"
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "here",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.go2ChangePasswordPage.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.DepositThreshold.Info.Here"
                                      )
                                    ) + "."
                                  )
                                ]
                              )
                            ])
                          : _c("v-card-text", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Account.PasswordPolicy.Alert.Info2")
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Account.PasswordPolicy.Alert.ChangePassword"
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "here",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.go2ChangePasswordPage.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.DepositThreshold.Info.Here"
                                      )
                                    ) + "."
                                  )
                                ]
                              )
                            ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canNotDeposit
                  ? _c(
                      "v-card",
                      { staticClass: "ms-chld" },
                      [
                        _c(
                          "span",
                          { staticClass: "ms-info-wrapper" },
                          [
                            _c("v-icon", { staticClass: "ms-info" }, [
                              _vm._v("info_outline")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                          _vm._v(
                            _vm._s(_vm.$t("Account.Ovelay.DepositNotAllowed"))
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canNotWithdraw
                  ? _c(
                      "v-card",
                      { staticClass: "ms-chld" },
                      [
                        _c(
                          "span",
                          { staticClass: "ms-info-wrapper" },
                          [
                            _c("v-icon", { staticClass: "ms-info" }, [
                              _vm._v("info_outline")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                          _vm._v(
                            _vm._s(_vm.$t("Account.Ovelay.WithdrawNotAllowed"))
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31e675d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e675d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/MessageCenter.vue
// module id = null
// module chunks = 